const SNAKE_CASE_TECHNOLOGIES = new Set<string>(['ruby'])

export function getInstanceVariableName(className: string, technology?: string): string {
  if (technology && SNAKE_CASE_TECHNOLOGIES.has(technology)) {
    return toSnakeCase(className)
  }
  return className.toLowerCase()
}

function toSnakeCase(input: string): string {
  return input
    .replace(/([a-z\d])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/^_+/, '')
    .toLowerCase()
}
